import { useAppSelector } from 'hooks';

export const useOfficeData = () => {
  const { buttonState, isButtonDisabled } = useAppSelector((state) => state.office);

  return { buttonState, isButtonDisabled };
};
